import { type FC } from 'react';
import { Link, type TestProps } from '@direct-frontend/components';
import { MERCHANTS_STORE_NAME_CHECK_HELP_URL } from '#shared/lib/const';
import styles from './CompanyNameCheckHint.module.css';

type CompanyNameCheckHintProps = TestProps & {
    isLinkUnderlined?: boolean;
};

export const CompanyNameCheckHint: FC<CompanyNameCheckHintProps> = ({
    isLinkUnderlined,
    'data-testid': dataTestId,
}) => (
    <>
        Укажите реальное название магазина. После проверки оно будет отображаться покупателям в Поиске и в чате с Алисой
        AI.{' '}
        <Link
            href={MERCHANTS_STORE_NAME_CHECK_HELP_URL}
            target="_blank"
            rel="noreferrer"
            className={isLinkUnderlined ? styles.linkUnderlined : undefined}
            data-testid={dataTestId}
        >
            Подробнее о проверке
        </Link>
    </>
);
